module.exports = __webpack_public_path__ + "static/img/1-3.6e5402a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/335/1-3.jpg
// module id = j8hA
// module chunks = 0